<template>
    <div>
        <div id="frame-practicien">
            <h1>Praticien</h1>
            <div id="container-facture">
                <div class="general-sous-menu">
                    <h3>Praticien</h3>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Agrée SNCF</label>
                    </div>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Agrée RATP</label>
                    </div>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Partenaire du régime des mines</label>
                    </div>
                    <div class="general-group">
                        <label>Numéro de Caisse </label>
                        <input type="number" value="991"/>
                    </div>
                </div>
                <div class="general-sous-menu">
                    <h3>Saisie des actes</h3>
                    <div class="general-group">
                        <label>Nombre de lignes à l'écran</label>
                        <input type="number" value="1" />
                    </div>
                </div>
                <div class="general-sous-menu">
                    <h3>Exécutant</h3>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Exécutant sur la saisie détaillée</label>
                    </div>
                </div>
                <div class="general-sous-menu">
                    <h3>Tarifs</h3>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Aligner systématiquement les tarifs de la CPAM</label>
                    </div>
                </div>
                <div class="general-sous-menu">
                    <h3>Parcours de soins : choix orienté par</h3>
                    <div class="general-group">
                        <input type="radio" name="practicienChoixOrientePar" />
                        <label> Choix sur click dans la liste</label>
                    </div>
                    <div class="general-group">
                        <input type="radio" name="practicienChoixOrientePar" />
                        <label> Choix sur click dans la liste</label>
                    </div>
                </div>
                <div class="general-sous-menu">
                    <h3>Suggestions</h3>
                    <div class="general-group">
                        <input type="checkbox"/>
                        <label>Activer les suggestions dans les listes</label>
                    </div>
                </div>
                <!--COLONE 2-->
                <div class="general-sous-menu">
                    <h3>CCAM : Classification Commune des Actes Médicaux</h3>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Activer la saisie CCAM</label>
                    </div>
                    <div class="general-group">
                        <label>Actes par défaut</label>
                        <select>
                            <option>Tous les actes</option>
                            <option>Les actes de ma spécialité</option>
                            <option>Les actes de ma spécialité</option>
                            <option>Mes actes personnels</option>
                            <option>Mes actes les plus préquents</option>
                        </select>
                    </div>
                    <div class="general-group">
                        <label>Recherche dans</label>
                        <select>
                            <option>Tous les actes</option>
                            <option>Libellé court</option>
                            <option>Libellé long</option>
                        </select>
                    </div>
                    <div class="general-group">
                        <label>Code d'activité</label>
                        <input type="number" value="1"/>
                        <label>Code phase</label>
                        <input type="number" value="0" />
                    </div>
                </div>
                <div class="general-sous-menu">
                    <h3>NGAP : Nomenclaure Générale des Actes Prof</h3>
                    <div class="general-sous-menu">
                        <input type="checkbox"/>
                        <label>Activer la saisie NGAP</label>
                    </div>
                </div>
                <div class="general-sous-menu">
                    <h3>STS : Tarification de la part complémentaire</h3>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Activer les STS</label>
                        <input type="checkbox" />
                        <label>Assistance automatique</label>
                    </div>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Messages d'information</label>
                    </div>
                    <div class="general-group">
                        <label>Formule par défaut</label>
                        <input type="text" />
                    </div>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Afficher les conventions uniques</label>
                    </div>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Validation automatique contrat</label>
                    </div>
                    <div class="general-group">
                        <input type="checkbox" />
                        <label>Validation automatique formule</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    @import 'parametre.css';
</style>
<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        data: function () {
            return {
                message: 'Parametre Praticitien'
            }
        },

        computed: {

        },

        methods: {

        },

        props: {

        },
        mounted() {

        }

        ,
        created() {

        }

    });
</script>
